import z from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';

export const USER_DELETE_TYPE = 'user/delete';

export const userDelete = defineCommand(
    USER_DELETE_TYPE,
    z.object({
        userIds: z.array(z.uuid()),
    }),
);

export const USER_CONFIRM_IDENTITY_TYPE = 'user/confirm-identity';

export const userConfirmIdentity = defineCommand(
    USER_CONFIRM_IDENTITY_TYPE,
    z.object({
        email: z.email(),
        sub: z.string(),
        currentPassword: z.string().min(1),
    }),
    z.object({
        confirmationToken: z.string(),
        maxAge: z.number(),
    }),
);

export const USER_CHANGE_EMAIL_TYPE = 'user/change-email';

export const userChangeEmail = defineCommand(
    USER_CHANGE_EMAIL_TYPE,
    z.object({
        email: z.email(),
        sub: z.string(),
        sessionId: z.string(),
        newEmail: z.email(),
        confirmationToken: z.string().min(1).optional(),
    }),
);
